import { enTranslations } from "./translations/en";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { zhTranslations } from "./translations/zh";

// Get saved language from localStorage or use default
const savedLanguage = localStorage.getItem("language") || "zh";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    zh: {
      translation: zhTranslations,
    },
  },
  lng: savedLanguage, // use saved language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Add event listener to save language changes
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
});

export default i18n;
